import React, { useEffect } from 'react';
import "./Articulos.scss";
import { Layout, SectionArticles, Cover, ArticleFolo, MainArticle } from "../../components";
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

const Articulos = ({ location }) => {

    const path = location.pathname;

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <div className="articulos">
            <Layout background="#1f2024">
                <div className="articulos__hero">
                    <div className="articulos__hero-main">
                        <MainArticle
                            tag="solucionarte"
                            date="8 de Agosto, 2021"
                            title="Como usar la plataforma"
                            description="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto alias ut accusantium quis dolores accusamus nisi porro, odit sit animi inventore officiis laboriosam quia, doloribus nesciunt tempore eius quas et quaerat facere incidunt reiciendis est quos sed. Quod voluptas asperiores officia eos adipisci nostrum voluptatem maxime cumque. Aspernatur, illum autem"
                            img="https://images.pexels.com/photos/5257319/pexels-photo-5257319.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                            size="2.3rem"
                        />

                    </div>
                    <div className="articulos__hero-secondary">
                        <MainArticle
                            tag="productividad"
                            date="8 de Agosto, 2021"
                            title="Siendo mas productiva"
                            description="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto alias ut accusantium quis dolores accusamus nisi porro, odit sit animi inventore officiis laboriosam quia, doloribus nesciunt tempore eius quas et quaerat facere incidunt reiciendis est quos sed. Quod voluptas asperiores officia eos adipisci nostrum voluptatem maxime cumque. Aspernatur, illum autem"
                            img="https://images.pexels.com/photos/6932375/pexels-photo-6932375.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                            size="1.3rem"
                            display="none"
                        />
                        <MainArticle
                            tag="tips"
                            date="8 de Agosto, 2021"
                            title="Elegi la persona adecuada"
                            description="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto alias ut accusantium quis dolores accusamus nisi porro, odit sit animi inventore officiis laboriosam quia, doloribus nesciunt tempore eius quas et quaerat facere incidunt reiciendis est quos sed. Quod voluptas asperiores officia eos adipisci nostrum voluptatem maxime cumque. Aspernatur, illum autem"
                            img="https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                            size="1.3rem"
                            display="none"
                        />
                    </div>
                </div>
                <div className="articulos__list">
                    <SectionArticles path={path}></SectionArticles>
                </div>
            </Layout>
        </div>
    )
}

export default Articulos;
